import React from "react";

/* ── Asset imports ── */
import HeroBgImg         from "../../asset/images/news/UnderstandingESPComponentsHero-bg.webp";
import ArticleImg        from "../../asset/images/news/article-35.webp";
import YoutubeIcon       from "../../asset/images/news/icon-youtube.svg";
import LinkedinIcon      from "../../asset/images/news/icon-linkedin.svg";
import BcSepIcon         from "../../asset/images/news/breadcrumb-separator.svg";
import ProfileIcon       from "../../asset/images/news/icon-profile.svg";
import CalendarIcon      from "../../asset/images/news/icon-calendar.svg";
import ClockIconImg      from "../../asset/images/news/icon-clock.svg";
import CommentsIcon      from "../../asset/images/news/icon-comments.svg";
import PreviousIcon      from "../../asset/images/news/icon-previous.svg";
import NextIcon          from "../../asset/images/news/icon-next.svg";
import FacebookIcon      from "../../asset/images/news/icon-facebook.svg";
import TwitterIcon       from "../../asset/images/news/icon-twitter.svg";
import LinkedinShareIcon from "../../asset/images/news/icon-linkedin-share.svg";

/* ── Recent post thumbnails ── */
import RecentImg1 from "../../asset/images/news/news-1.webp";
import RecentImg2 from "../../asset/images/news/news-2.webp";
import RecentImg3 from "../../asset/images/news/news-3.webp";
import RecentImg4 from "../../asset/images/news/news-4.webp";

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .uesp { font-family: 'Poppins', sans-serif; font-size: 14px; color: #202020; background: #fff; }

  /* ══ HERO ══ */
  .uesp-hero {
    position: relative; width: 100%; height: 460px;
    overflow: hidden;
  }
  .uesp-hero-bg {
    position: absolute; inset: 0;
    width: 100%; height: 100%;
    object-fit: cover; object-position: center right; display: block;
  }
  .uesp-hero-overlay {
    position: absolute; inset: 0;
    // background: linear-gradient(
    //   to right,
    //   rgba(0,0,0,0.85) 0%,
    //   rgba(0,0,0,0.65) 38%,
    //   rgba(0,0,0,0.10) 100%
    // );
  }
  .uesp-hero-content {
    position: absolute; inset: 0;
    display: flex; flex-direction: column; justify-content: center;
    padding: 0 102px;
    max-width: 1600px; margin: 0 auto; left: 0; right: 0;
  }
  .uesp-hero-title {
    font-family: 'Poppins', sans-serif;
    font-size: 42px; font-weight: 600; color: #fff;
    line-height: 120%; margin-bottom: 15px; max-width: 575px;
  }
  .uesp-hero-divider {
    width: 479px; height: 2px;
    background: #EB2019; border: none; margin-bottom: 15px;
  }
  .uesp-hero-subtitle {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #fff;
    line-height: 160%; max-width: 479px;
  }

  /* ══ BREADCRUMB ══ */
  .uesp-breadcrumb { width: 100%; padding: 40px 0 0 0; }
  .uesp-breadcrumb-inner {
    max-width: 1600px; margin: 0 auto; padding: 0 102px;
    display: flex; align-items: center; flex-wrap: wrap;
  }
  .uesp-bc-item {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 500; color: #202020;
    text-decoration: none; display: flex; align-items: center; gap: 14px;
    transition: color 0.15s;
  }
  .uesp-bc-item:hover { color: #EB2019; }
  .uesp-bc-sep {
    display: flex; align-items: center; justify-content: center;
    width: 24px; height: 24px; border-radius: 50%;
    margin: 0 8px; flex-shrink: 0;
  }
  .uesp-bc-sep img { width: 24px; height: 24px; display: block; }
  .uesp-bc-item.active { color: #202020; font-weight: 500; }

  /* ══ INNER ══ */
  .uesp-inner { max-width: 1600px; margin: 0 auto; padding: 0 102px; }

  /* ══ MAIN ══ */
  .uesp-main-section { padding: 80px 0 120px 0; }
  .uesp-main-row { display: flex; align-items: flex-start; gap: 89px; }

  /* ══ ARTICLE ══ */
  .uesp-article { flex: 1; min-width: 0; }

  .uesp-meta-bar {
    display: flex; align-items: center; flex-wrap: wrap; gap: 20px;
    margin-bottom: 30px;
  }
  .uesp-meta-item {
    display: flex; align-items: center; gap: 8px;
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    border-right: 1px solid #7A7A7A; padding-right: 15px;
  }
  .uesp-meta-item:last-child { border-right: none; padding-right: 0; }
  .uesp-meta-item img { width: 24px; height: 24px; display: block; flex-shrink: 0; }

  .uesp-article-title {
    font-family: 'Poppins', sans-serif;
    font-size: 32px; font-weight: 600; color: #202020;
    line-height: 140%; margin-bottom: 30px;
  }

  .uesp-article-img {
    width: 100%; height: 450px;
    object-fit: cover; border-radius: 10px;
    display: block; margin: 45px 0 30px 0;
  }

  .uesp-article-body {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%;
  }
  .uesp-article-body p { margin-bottom: 20px; }
  .uesp-article-body p:last-child { margin-bottom: 0; }

  .uesp-h2 {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 600; color: #202020;
    margin: 0px 0 0px 0; line-height: 160%; display: block;
  }

  /* Numbered ol list */
  .uesp-article-body ol {
    list-style: none; margin: 20px 0 30px 0; padding: 0;
    display: flex; flex-direction: column; gap: 20px;
    counter-reset: uesp-counter;
  }
  .uesp-article-body ol li {
    display: flex; align-items: flex-start; gap: 0px;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%; counter-increment: uesp-counter; 
  }
  .uesp-article-body ol li::before {
    content: counter(uesp-counter) '.';
    font-weight: 600; color: #202020;
    flex-shrink: 0; min-width: 20px;
  }
  .uesp-article-body ol li > span { flex: 1; }

  .uesp-article-body strong { font-weight: 600; color: #202020; }

  .uesp-red-link { color: #EB2019; text-decoration: underline; font-weight: 600; }
  .uesp-red-link:hover { opacity: 0.8; }

  .uesp-red-link-plain { color: #EB2019; text-decoration: underline; font-weight: 400; }
  .uesp-red-link-plain:hover { opacity: 0.8; }

  /* Hashtags */
  .uesp-hashtags {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 700; color: #202020;
    line-height: 160%; margin-top: 15px;
  }

  /* ══ BOTTOM ROW ══ */
  .uesp-bottom-row {
    display: flex; align-items: center; justify-content: space-between;
    margin-top: 30px; padding-top: 30px;
    border-top: 1px solid #C7C7C7; flex-wrap: wrap; gap: 16px;
  }
  .uesp-bottom-nav { display: flex; align-items: center; gap: 60px; }
  .uesp-nav-btn {
    display: inline-flex; align-items: center; gap: 20px;
    font-family: 'Poppins', sans-serif;
    font-size: 20px; font-weight: 500; color: #202020;
    text-decoration: none; background: none; border: none;
    cursor: pointer; transition: color 0.15s;
  }
  .uesp-nav-btn:hover { color: #EB2019; }
  .uesp-nav-btn img { width: 40px; height: 40px; display: block; }

  .uesp-share-icons { display: flex; align-items: center; gap: 20px; }
  .uesp-share-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 50%;
    text-decoration: none; flex-shrink: 0; transition: opacity 0.15s;
  }
  .uesp-share-icon:hover { opacity: 0.85; }
  .uesp-share-icon img { width: 44px; height: 44px; display: block; }

  /* ══ SIDEBAR ══ */
  .uesp-sidebar { flex: 0 0 475px; }
  .uesp-sidebar-block { margin-bottom: 60px; }
  .uesp-sidebar-title {
    font-family: 'Poppins', sans-serif;
    font-size: 24px; font-weight: 600; color: #202020;
    margin-bottom: 30px; padding-bottom: 20px;
    border-bottom: 1px solid #EB2019; line-height: 120%;
  }
  .uesp-recent-list { display: flex; flex-direction: column; gap: 30px; }
  .uesp-recent-item {
    display: flex; align-items: flex-start; gap: 12px;
    text-decoration: none; color: #202020;
  }
  .uesp-recent-item:hover .uesp-recent-title { color: #EB2019; }
  .uesp-recent-img {
    flex: 0 0 200px; height: 120px;
    object-fit: cover; border-radius: 6px; display: block;
  }
  .uesp-recent-body { flex: 1; min-width: 0; }
  .uesp-recent-title {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%; transition: color 0.15s;
    display: -webkit-box; -webkit-line-clamp: 3;
    -webkit-box-orient: vertical; overflow: hidden;
  }
  .uesp-social-icons { display: flex; align-items: center; gap: 30px; }
  .uesp-social-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 6px; overflow: hidden;
    text-decoration: none; transition: opacity 0.15s;
  }
  .uesp-social-icon:hover { opacity: 0.8; }
  .uesp-social-icon img { width: 44px; height: 44px; object-fit: contain; display: block; }

  /* ══ RESPONSIVE — TABLET ══ */
  @media (max-width: 768px) {
    .uesp-hero             { height: 350px; }
    .uesp-hero-content     { padding: 0 32px; }
    .uesp-hero-title       { font-size: 30px; }
    .uesp-hero-divider     { width: 100%; max-width: 479px; }
    .uesp-breadcrumb       { padding: 24px 0 0 0; }
    .uesp-breadcrumb-inner { padding: 0 32px; }
    .uesp-inner            { padding: 0 32px; }
    .uesp-main-section     { padding: 48px 0 60px 0; }
    .uesp-main-row         { flex-direction: column; gap: 48px; }
    .uesp-sidebar          { flex: none; width: 100%; }
    .uesp-article-title    { font-size: 20px; }
  }

  /* ══ RESPONSIVE — MOBILE ══ */
  @media (max-width: 480px) {
    .uesp-hero             { height: 360px; }
    .uesp-hero-content     { padding: 0 16px; }
    .uesp-hero-title       { font-size: 24px; margin-bottom: 15px; }
    .uesp-hero-divider     { width: 100%; }
    .uesp-hero-subtitle    { font-size: 14px; }
    .uesp-breadcrumb       { padding: 30px 0 0 0; }
    .uesp-breadcrumb-inner { padding: 0 16px; }
    .uesp-bc-item          { font-size: 14px; gap: 14px; }
    .uesp-bc-sep           { width: 18px; height: 18px; margin: 0 4px; }
    .uesp-bc-sep img       { width: 22px; height: 22px; }
    .uesp-inner            { padding: 0 16px; }
    .uesp-main-section     { padding: 30px 0 60px 0; }
    .uesp-main-row         { flex-direction: column; gap: 60px; }
    .uesp-sidebar          { flex: none; width: 100%; }
    .uesp-article-title    { font-size: 20px; margin-bottom: 15px; }
    .uesp-article-body     { font-size: 14px; }
   
    .uesp-article-body p   { margin-bottom: 15px;  }
    .uesp-article-body ol  { margin: 20px 0 20px 0; gap: 20px; }
    .uesp-article-body ol li { font-size: 14px; }
    .uesp-article-body strong { font-size: 16px; }
    .uesp-meta-item        { font-size: 14px; }
    .uesp-article-img      { margin: 30px 0 15px 0; height: 250px; }
    .uesp-h2               { font-size: 16px; margin: 30px 0 0px 0; }
    .uesp-hashtags         { margin-top: 30px; font-size: 14px; }
    .uesp-nav-btn img      { width: 24px; height: 24px; }
    .uesp-nav-btn          { font-size: 14px; }
    .uesp-share-icon img   { width: 34px; height: 34px; }
    .uesp-sidebar-title    { font-size: 20px; }
    .uesp-bottom-nav { gap: 20px;}
  }
`;

const recentPosts = [
 {
       img: RecentImg1,
       title: "Battery Formation & Testing: Enabling The Rise Of EV & Energy Storage Manufacturing",
       slug: "battery-formation-testing-enabling-the-rise-of-ev-energy-storage-manufacturing/",
     },
     {
       img: RecentImg2,
       title: "Next-Gen ESP Power Supplies: Upgrades and Sustainability in Industrial Air Pollution Control",
       slug: "next-gen-esp-power-supplies-upgrades-and-sustainability-in-industrial-air-pollution-control/",
     },
     {
       img: RecentImg3,
       title: "Green Hydrogen Power Electronics: Ador Powertron at the Forefront of Electrolyzer Rectifier Setups",
       slug: "green-hydrogen-power-electronics-ador-powertron-at-the-forefront-of-electrolyzer-rectifier-setups/",
     },
     {
       img: RecentImg4,
       title: "Transformer Bushings: Types & Importance",
       slug: "transformer-bushings-guide/",
     },
];

export default function UnderstandingESPComponents() {
  return (
    <div className="uesp">
      <style>{CSS}</style>

      {/* ══ HERO ══ */}
      <section className="uesp-hero">
        <img className="uesp-hero-bg" src={HeroBgImg} alt="Understanding ESP Components Hero" />
        <div className="uesp-hero-overlay" />
        <div className="uesp-hero-content">
          <h1 className="uesp-hero-title">
            Understanding ESP Components: What Parts Make the System Work?
          </h1>
          <hr className="uesp-hero-divider" />
          <p className="uesp-hero-subtitle">
            Everything we do is designed, whether we're producing a magazine, a website, or a bridge. Design is really the creative invention that designs everything.
          </p>
        </div>
      </section>

      {/* ══ BREADCRUMB ══ */}
      <nav className="uesp-breadcrumb" aria-label="Breadcrumb">
        <div className="uesp-breadcrumb-inner">
          <a href="/" className="uesp-bc-item">Home</a>
          <span className="uesp-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <a href="/news" className="uesp-bc-item">News &amp; Updates</a>
          <span className="uesp-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <span className="uesp-bc-item active">Post</span>
        </div>
      </nav>

      {/* ══ MAIN ══ */}
      <section className="uesp-main-section">
        <div className="uesp-inner">
          <div className="uesp-main-row">

            {/* ── ARTICLE ── */}
            <article className="uesp-article">

              {/* Meta bar */}
              <div className="uesp-meta-bar">
                <span className="uesp-meta-item"><img src={ProfileIcon} alt="author" /> Admin</span>
                <span className="uesp-meta-item"><img src={CalendarIcon} alt="date" /> November 15, 2024</span>
                <span className="uesp-meta-item"><img src={ClockIconImg} alt="time" /> 10:14 am</span>
                <span className="uesp-meta-item"><img src={CommentsIcon} alt="comments" /> No Comments</span>
              </div>

              {/* Title */}
              <h1 className="uesp-article-title">
                Understanding ESP Components: What Parts Make the System Work?
              </h1>

              {/* Body */}
              <div className="uesp-article-body">

                <span className="uesp-h2">Understanding Esp Spares and Services</span>

                <p><a href="/news/igbt-technology-esp" className="uesp-red-link-plain">ESP spares and services</a> refer to the essential replacement parts and maintenance solutions that ensure the smooth and efficient operation of an Electrostatic Precipitator (ESP) system. These components include discharge electrodes, collecting plates, insulators, rappers, and control systems, all of which can wear down over time due to continuous use in industrial environments. Regular servicing and timely replacement of spares not only prevent unexpected downtime but also enhance the overall performance and lifespan of the ESP. Choosing high-quality spares and expert servicing helps maintain emission standards, reduces operational costs, and supports sustainable plant operations.</p>

                <span className="uesp-h2">What are ESP spares and why are they important?</span>

                <p>ESP spares refer to the replacement parts used in Electrostatic Precipitators, which are critical for maintaining the efficiency and performance of air pollution control systems in industries like power generation, cement, and steel manufacturing. These spares include components such as discharge electrodes, collecting plates, rapper coils, insulators, and transformer rectifier units, all of which play key roles in ensuring the ESP operates reliably. Regular replacement and maintenance of these parts help minimize downtime, maintain emission standards, and extend the overall lifespan of the ESP system.</p>

                <p>Electrostatic Precipitators (ESPs) are crucial in capturing airborne particles like dust, fly ash, and aerosols from industrial exhaust gases, mainly from boiler systems. By creating a powerful electrostatic field, ESPs attract and remove suspended particulate matter from the exhaust, helping industries maintain cleaner air output. The key to their effective operation is specific ESP components, each contributing to efficient particle removal. Hence, <a href="/news/igbt-technology-esp" className="uesp-red-link-plain">ESP spares and services</a> maintenance is crucial.</p>

                {/* Article image */}
                <img className="uesp-article-img" src={ArticleImg} alt="Understanding ESP Components" />

                <p> Let's explore these components, their roles, and why ESP spares and services are vital for smooth operation.</p>

                <span className="uesp-h2">How an ESP Works</span>

                <p>An ESP system's heart is a high-voltage power supply that generates an electrostatic field strong enough to capture particles from the gas stream. This power supply unit converts standard AC power into high-voltage DC, creating the electric field that enables particle capture. Without this solid electrostatic field, particles would pass through exhaust systems and pollute the environment.</p>

                <span className="uesp-h2">Key ESP Components</span>

                <ol>
                  <li><span><strong>Transformer-Rectifier (TR) Unit</strong><br />
                  The <a href="/news/transformer-rectifiers-coal-power" className="uesp-red-link-plain">transformer rectifier</a> (TR) unit is a critical component of the ESP, responsible for converting low-voltage AC from the power source into high-voltage DC output. This high-voltage DC is essential to maintaining the solid electrostatic field required to capture particles efficiently. Available in single-phase and three-phase configurations, TR units are selected based on the ESP's performance requirements, with three-phase units generally offering better performance in dust separation. At Ador, we offer a range of high-voltage TR units with customizable input and output specifications. Our TR sets can accommodate input voltages from 380V to 690V and frequencies of 50Hz or 60Hz. Output voltage can range from 30 kVp to 200 kVp, with current options from 50 mA up to 5000 mA. This customization ensures that each ESP can be tailored to meet the unique needs of a specific industrial application.</span></li>

                  <li><span><strong>Control Cubicle</strong><br />
                  The Control Cubicle optimizes the output of the ESP power supply for various operational conditions. It regulates the power flowing through the ESP system, ensuring stable operation even under changing load conditions. A well-calibrated Control Cubicle maximizes particle capture efficiency, reduces energy consumption, and extends the life of the ESP components.</span></li>

                  <li><span><strong>Electrostatic Field Plates</strong><br />
                  Inside the ESP, a series of metal plates create an electric field that attracts particles from the gas stream. When particles pass through this field, they become charged and are attracted to collection plates, where they accumulate until they are cleaned out of the system. Regular maintenance and cleaning of these plates in ESP spares and services are essential for consistent performance.</span></li>

                  <li><span><strong>Rapping Mechanism</strong><br />
                  Over time, dust and particles build up on the collection plates. The rapping mechanism periodically shakes the plates to dislodge this buildup, ensuring that the plates remain effective at capturing particles. This mechanism is essential for keeping the ESP functioning efficiently and preventing clogs or blockages.</span></li>
                </ol>

                <span className="uesp-h2">Insulators: Safeguarding Electrical Integrity</span>

                <p>Insulators are pivotal in maintaining the electrical integrity of an Electrostatic Precipitator (ESP). They prevent unintended electrical discharges by isolating high-voltage components from grounded structures. Typically made from materials like porcelain or glass, these insulators must withstand high voltages and resist contamination from dust and moisture. Regular inspection and cleaning are essential to prevent tracking and flashovers, which can compromise the ESP's efficiency and safety.</p>

                <span className="uesp-h2">Hoppers: Efficient Dust Collection and Removal</span>

                <p>Positioned at the base of the ESP, hoppers serve as collection points for the particulate matter dislodged from the collecting plates. These structures are designed to funnel the collected dust into storage or disposal systems, ensuring continuous operation without manual intervention. Properly designed hoppers prevent re-entrainment of particles into the gas stream and facilitate easy maintenance. Incorporating features like heating elements can prevent condensation and material buildup, especially in humid environments.</p>

                <span className="uesp-h2">Shell and Casing: Structural Support and Protection</span>

                <p>The shell or casing of an ESP provides the necessary structural support to house all internal components securely. It also acts as a barrier, protecting the internal environment from external contaminants and weather conditions. A well-designed casing ensures optimal airflow distribution, minimizes leakage, and contributes to the overall durability and longevity of the ESP system. Regular inspections can identify structural weaknesses or corrosion, allowing for timely maintenance and repairs.</p>

                <span className="uesp-h2">Why ESP Spares and Services Matter</span>

                <p>Over time, regular wear and tear can impact the effectiveness of ESP components. Transformer-rectifier units, control cubicles, and rapping mechanisms need routine inspection and maintenance to keep the ESP operating at peak performance. Access to high-quality ESP spares and services ensures minimal downtime and extends the life of the ESP system.</p>

                <span className="uesp-h2">Ador's Commitment to Reliable ESP Solutions</span>

                <p>As a global leader in ESP components, Ador provides complete power supply units, including high-quality TR sets, Control Cubicles, and customized ESP solutions. Our capability to adapt ESP components to meet specific project needs—whether in voltage, current, or installation requirements—ensures that each ESP we support is optimized for long-term efficiency and performance.</p>

                <p>Contact us for customized solutions, quality <strong>ESP spares and services</strong> designed to meet your requirements.</p>

                <p>With over 20,000+ High-Voltage Transformer-Rectifiers units supplied &amp; 200+ satisfied customers over the past 35 years to its credit, it has earned a strong footprint within the Power, Cement, Steel, Pulp and Paper industries across 82 countries spanning 6 continents.</p>

                <p>ADOR T/Rs use in-house software. In addition, OEM software can be incorporated to manage and control the ESP.</p>

                <p>ADOR is committed to investing in these areas and will research innovative solutions to fight pollution and use sustainable energy. To achieve this goal, Ador has a strategic technology-sharing partnership with Redkoh, the world's foremost precipitator controls company.</p>

                <p className="uesp-hashtags"><strong>#ESPSpares #ElectrostaticPrecipitator #PowerConversion #AdorGroup #IndustrialDustControl #ESPComponents</strong></p>

              </div>

              {/* ── Bottom row ── */}
              <div className="uesp-bottom-row">
                <div className="uesp-bottom-nav">
                  <a href="/news/igbt-technology-esp" className="uesp-nav-btn">
                    <img src={PreviousIcon} alt="Previous" />
                    Previous
                  </a>
                  <a href="/news/environmental-benefits-emission-control" className="uesp-nav-btn">
                    Next
                    <img src={NextIcon} alt="Next" />
                  </a>
                </div>
                <div className="uesp-share-icons">
                  <a href="https://www.facebook.com/sharer.php?u=https://adorpowertron.com/understanding-esp-components-what-parts-make-the-system-work/" className="uesp-share-icon" aria-label="Facebook" target="blank">
                    <img src={FacebookIcon} alt="Facebook" />
                  </a>
                  <a href="https://x.com/i/jf/onboarding/web?redirect_after_login=%2Fintent%2Ftweet%3Ftext%3D%2520https%3A%2F%2Fadorpowertron.com%2Funderstanding-esp-components-what-parts-make-the-system-work%2F&mode=login" className="uesp-share-icon" aria-label="Twitter"  target="blank">
                    <img src={TwitterIcon} alt="Twitter" />
                  </a>
                  <a href="https://www.linkedin.com/login/?session_redirect=https%3A%2F%2Fwww.linkedin.com%2FshareArticle%3Fmini%3Dtrue%26url%3Dhttps%3A%2F%2Fadorpowertron.com%2Funderstanding-esp-components-what-parts-make-the-system-work%2F%26title%3DUnderstanding%2520ESP%2520Spares%2520and%2520Services%2520%257C%2520Adorpower%26summary%3D%26source%3Dhttps%3A%2F%2Fadorpowertron.com%2Funderstanding-esp-components-what-parts-make-the-system-work%2F" className="uesp-share-icon" aria-label="LinkedIn"  target="blank">
                    <img src={LinkedinShareIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </article>

            {/* ── SIDEBAR ── */}
            <aside className="uesp-sidebar">

              {/* Recent Posts */}
              <div className="uesp-sidebar-block">
                <p className="uesp-sidebar-title">Recent Posts</p>
                <div className="uesp-recent-list">
                  {recentPosts.map((post, idx) => (
                    <a key={idx} href={`/news/${post.slug}`} className="uesp-recent-item">
                      <img src={post.img} alt={post.title} className="uesp-recent-img" />
                      <div className="uesp-recent-body">
                        <span className="uesp-recent-title">{post.title}</span>
                      </div>
                    </a>
                  ))}
                </div>
              </div>

              {/* Social Media */}
              <div className="uesp-sidebar-block">
                <p className="uesp-sidebar-title">Social Media</p>
                <div className="uesp-social-icons">
                  <a href="https://www.youtube.com/@adorIndia" className="uesp-social-icon" aria-label="YouTube"  target="blank">
                    <img src={YoutubeIcon} alt="YouTube" />
                  </a>
                  <a href="https://www.linkedin.com/uas/login?session_redirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2F139191%2Fadmin%2F" className="uesp-social-icon" aria-label="LinkedIn"  target="blank">
                    <img src={LinkedinIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </aside>

          </div>
        </div>
      </section>

    </div>
  );
}